import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  createDoc,
  getFlutterTimeFromSeconds,
  getFlutterTimeFromSecondsFormatTime,
  updateDocDataField,
} from "../models/DataFunctions.js";

import CheckBoxGrey from "../textfields/CheckBoxGrey.js";

import moment from "moment";
import SmallSpinner from "../loading/SmallSpinner.js";
import { DatePicker } from "antd";
import { useSnackbar } from "notistack";
import MLTF1 from "../textfields/MLTF1.js";
import MLTFGPT1 from "../textfields/MLTFGPT1.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import { useAppContext } from "../config/AppContext.js";
import sendDemandRDVEmail from "../api/folder/sendDemandRDVEmail.js";
import { setDoc } from "firebase/firestore";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import RangeDatePicker from "../textfields/RangeDatePicker.js";
import updateDocApi from "../api/database/updateDocApi.js";
import MLTFGPT3 from "../textfields/MLTFGPT3.js";
import dayjs from "dayjs";

const RDV = ({ document, folder, orgData, onClose, onUpdate }) => {
  const [loadingData = false, setLoadingData] = useState(false);
  const { RangePicker } = DatePicker;
  const [dates, setDates] = useState(null);
  const [value, setValue] = useState("");
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [rangeSeconds, setRangeSeconds] = useState({
    start_seconds: null,
    end_seconds: null,
  });
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const onChangeRDVDates = async (dates) => {
    setDates(dates);
  };

  const handleGenerateRDV = async () => {
    if (
      rangeSeconds.start_seconds === null ||
      rangeSeconds.end_seconds === null
    ) {
      handleClickVariant("Veuillez sélectionner une plage valide", "error");
      return;
    }
    setLoadingData(true);

    let startdate = getFlutterTimeFromSeconds(rangeSeconds.start_seconds);
    let enddate = getFlutterTimeFromSeconds(rangeSeconds.end_seconds);

    await updateDocApi(
      folder.ref,
      {
        startdate: startdate,
        enddate: enddate,
        rdv_comment: value,
        rdv_state: "wait",
      },
      prefix
    );

    // don't use setDoc to not overwrite the folder data

    const token = await getOrRefreshFirebaseToken();

    await sendDemandRDVEmail(folder.id, value, token, prefix);

    await onUpdate();
    handleClickVariant("RDV demandé", "success");
    onClose();
    setLoadingData(false);
  };

  return (
    <div className="flex flex-col bg-white rounded-3xl ">
      <div className="w-c300 text-h3 p-4 border-b-1 flex flex-row justify-between">
        Demande de RDV
        <div className="flex text-shadow_50 cursor-pointer" onClick={onClose}>
          Fermer
        </div>
      </div>

      <div className="flex flex-col p-4 bg-neutral-50">
        <div className="w-c300 text-h3 text-shadow_50">
          Sélectionnez une plage de disponibilité pour organiser un RDV avec
          votre bureau de contrôle.
        </div>
        <Space y={15} />

        <RangeDatePicker
          value={rangeSeconds}
          onChange={setRangeSeconds}
          transparent={false}
        ></RangeDatePicker>
        <Space y={10} />
        <MLTFGPT3
          label="Commentaire"
          placeholder="Entrez un commentaire"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          rows={4}
        ></MLTFGPT3>
      </div>
      <div className="flex flex-row gap-2 justify-end p-4 border-t-1">
        <PrimaryButton
          onClick={handleGenerateRDV}
          disabled={
            loadingData ||
            !rangeSeconds.start_seconds ||
            !rangeSeconds.end_seconds
          }
        >
          Confirmer <SmallSpinner loading={loadingData} />
        </PrimaryButton>
      </div>
    </div>
  );
};

export default RDV;
